var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AuthProvider } from '@agentguru/auth';
import { AppProviders } from './AppProviders';
import { ENV } from './configurations/env';
import { AppRoutes } from './routes/AppRoutes';
import './helpers/setViewportProperty';
export default function App() {
    return (_jsx(AuthProvider, __assign({ domain: ENV.AUTH0_DOMAIN, clientId: ENV.AUTH0_CLIENT_ID, audience: ENV.AUTH0_AUDIENCE, redirectUri: window.location.origin }, { children: _jsx(AppProviders, { children: _jsx(AppRoutes, {}) }) })));
}
